import axios from 'axios';

export const contractApi = axios.create({
  baseURL: process.env.REACT_APP_CONTRACTS_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const authClient = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export const legalClient = axios.create({
  baseURL: process.env.REACT_APP_LEGAL_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});
